export default __webpack_public_path__ + "static/media/wK.d45e8c43.svg";